import useKlydoMutation, {
  UseKlydoMutationOptions,
} from "../../../../components/hooks/useKlydoMutation";
import adminApiClient from "../../../../api/admin";

const useVerifyEmailMutation = (
  options?: UseKlydoMutationOptions<void, string>,
) => {
  return useKlydoMutation({
    mutationKey: ["verify-user-email"],
    mutationFn: (userId: string) => adminApiClient.setUserEmailVerified(userId),
    ...options,
  });
};

export default useVerifyEmailMutation;
